import { MessageService } from 'primeng/api'

import { guardarBlobComo } from '@data/utils/descarga-archivo.util'
import { Descarga } from '../interfaces/f098.interface'

/**
 * Entrega una descarga de reporte: guarda el archivo con el nombre del servidor, o avisa con el mensaje
 * del servidor si no se pudo generar.
 *
 * Devuelve `true` si hubo archivo. Es el único punto donde las vistas de Cobranza sueltan un reporte:
 * así todas avisan igual y nadie vuelve a decir «no se pudo» sin decir por qué.
 */
export function entregarDescarga(d: Descarga, nombrePorOmision: string, toast: MessageService, titulo: string): boolean {
  if (!d.blob) {
    toast.add({ severity: 'error', summary: titulo, detail: d.msg || 'No se pudo generar el archivo', life: 8000 })
    return false
  }
  const nombre = d.fileName || nombrePorOmision
  guardarBlobComo(d.blob, nombre)
  toast.add({ severity: 'success', summary: titulo, detail: `Se descargó ${nombre}`, life: 4000 })
  return true
}
